import enums from "./../enums";

const thirdParty = (
	state = {
		casino: {
			games: [],
			offset: 0,
			total: 0,
		},
		searchedGames: {
			games: [],
			offset: 0,
		},
		casinoLoading: false,
		liveCasinoParams: {},
		liveCasinoLoading: false,
		liveCasinoError: "",
		affiliates: null,
		favoriteGames: [],
		containerConfigs: [],
		casinoContainerLoading: false,
	},
	{ type, payload }
) => {
	switch (type) {
		case enums.CASINO_GAMES_LOADING: {
			return { ...state, casinoLoading: payload };
		}
		case enums.CASINO_GAMES_LIST: {
			let casino = { ...state.casino };
			if (payload.isUpdate) {
				casino = {
					...casino,
					games: [...casino.games, ...payload.games],
					count: payload.count,
					total: payload.total,
				};
			} else {
				casino = payload;
			}
			return { ...state, casino };
		}
		case enums.CASINO_SEARCHED_GAMES_LIST: {
			let searchedGames = { ...state.searchedGames };
			if (payload.isUpdate && payload.games.length > 0) {
				searchedGames = {
					...searchedGames,
					games: [...searchedGames.games, ...payload.games],
					count: payload.count,
					total: payload.total,
				};
			} else {
				searchedGames = payload;
			}
			return { ...state, searchedGames };
		}
		case enums.CLEAR_3PARTY_PROVIDERS: {
			return { ...state, affiliates: null };
		}
		case enums.FAVORITE_GAMES: {
			return { ...state, favoriteGames: payload };
		}
		case enums.LIVE_CASINO_LAUNCH_SUCCESS: {
			return { ...state, liveCasinoParams: payload };
		}
		case enums.LIVE_CASINO_LAUNCH_LOADING: {
			return { ...state, casinoLoading: payload };
		}
		case enums.GEOLOCATION_TRACKING_NOT_ENABLED: {
			return { ...state, geolocationTrackingNotEnabled: payload };
		}
		case enums.LIVE_CASINO_LAUNCH_ERROR: {
			return { ...state, liveCasinoError: payload };
		}
		case enums.CASINO_GAME_TYPE_LIST:
			return { ...state, gameTypes: payload.gameTypes.map((types) => types.name) };
		case enums.CASINO_GAME_PROVIDER_LIST:
			return { ...state, gameProviders: payload.providers.map((provider) => provider.name) };
		case enums.CASINO_GAME_CATEGORY_LIST:
			if (payload.isLocalGameCategory) {
				return {
					...state,
					gameCategories: payload.categories
						.map((category) => ({
							name: category.name,
							localize: category.localize,
							isLive: category.isLive,
						}))
						.filter((category) =>
							payload.isLive !== null ? category.isLive === payload.isLive : true
						),
				};
			}

			return {
				...state,
				gameCategories: payload.remoteCategories.map((category) => ({
					name:
						category.linkedLocalCategory?.length > 0
							? category.linkedLocalCategory
							: category.name,
					localize: category.local,
				})),
			};
		case enums.CASINO_GAME_AFFILIATE_LIST:
			return {
				...state,
				affiliates: payload.sort((a, b) => a.affiliate.localeCompare(b.affiliate)),
			};
		case enums.CASINO_CONTAINER_CONFIGS:
			return {
				...state,
				containerConfigs: payload,
			};
		case enums.CASINO_CONTAINER_CONFIGS_LOADING:
			return {
				...state,
				casinoContainerLoading: payload,
			};
		default:
			return { ...state };
	}
};

export default thirdParty;
